import { actionTypes, formModes, alfrescoTypes, documentStatuses, documentBpActions as bpActions } from '../../constants';
import i18next from "../../i18n";
export const documentTabs = {
	information: "information",
	docs: "docs",
	connections: "connections",
	signers: "signers",
	comments: "comments",
    financialinfo: "financialinfo",
    contactinfo: "contactinfo",
    editingRights: "editingRights"
}
export const actions = [
    {
        title: i18next.t("save"),
        btnClass: "btn-primary",
        type: actionTypes.save,
        statuses: [documentStatuses.All],
        modes: [formModes.create, formModes.edit]
    },
    {
        title: i18next.t("close"),
        btnClass: "btn-no-fill",
        type: actionTypes.cancel,
        modes: [formModes.all]
    }];
export const documentSettings = {
    statuses: {},
    actions: [],
    "documentTable": {
        "name": "documentTable",
        "onPageActions": [
            {
                "title": i18next.t("view"),
                "btnClass": "btn-primary",
                "type": actionTypes.preview,
                "sortIndex": 0,
                "isMultiaction": false,
                "modes": [formModes.all]
            },
            {
                "title": i18next.t("remove"),
                "btnClass": "btn-no-fill",
                "type": actionTypes.remove,
                "sortIndex": 1,
                "isMultiaction": true,
                "modes": [formModes.create, formModes.edit]
            }
        ]
    },
    mainDocumentsTable: {
        columns: [
            {
                "id": "0",
                "name": "Id",
                "headerName": "",
                "type": "string",
                "hidden": true
            },
            {
                "id": "1",
                "name": "FileName",
                "CanSort": true,
                "headerName": i18next.t("documentName"),
                "type": "string"
            }
        ],
        actions: [
            {
                "title": i18next.t("view"),
                "btnClass": "btn-primary",
                type: actionTypes.preview,
                "sortIndex": 0
            },
            {
                "title": i18next.t("download"),
                "btnClass": "btn-secondary",
                type: actionTypes.download,
                "sortIndex": 1,
                "isMultiaction": true
            },
            {
                "title": i18next.t("changeFile"),
                "btnClass": "btn-no-fill",
                type: actionTypes.change,
                "sortIndex": 2,
                "isMultiaction": false
            }
        ]
    },
    additionalDocumentsTable: {
        columns: [
            {
                "id": "0",
                "name": "Id",
                "headerName": "",
                "type": "string",
                "hidden": true
            },
            {
                "id": "1",
                "name": "FileName",
                "CanSort": true,
                "headerName": i18next.t("documentName"),
                "type": "string"
            }
        ],
        actions: [
            {
                "title": i18next.t("view"),
                "btnClass": "btn-primary",
                type: actionTypes.preview,
                "sortIndex": 0
            },
            {
                "title": i18next.t("download"),
                "btnClass": "btn-secondary",
                type: actionTypes.download,
                "sortIndex": 1,
                "isMultiaction": true
            },
            {
                "title": i18next.t("remove"),
                "btnClass": "btn-no-fill",
                type: actionTypes.remove,
                "sortIndex": 2,
                "isMultiaction": true
            }
        ]
    },
    responsiblePersonTable: {
        columns: [
            {
                "id": "0",
                "name": "Id",
                "headerName": "",
                "type": "string",
                "hidden": true
            },
            {
                "id": "1",
                "name": "FullName",
                "headerName": i18next.t("fullName"),
                "type": "string"
            },
            {
                "id": "3",
                "name": "Email",
                "headerName": i18next.t("email"),
                "type": "email"
            },
            {
                "id": "14",
                "name": "Position",
                "headerName": i18next.t("positionHeld"),
                "type": "string"
            }
        ],
        actions: []
    },
    "additionalCounterpartiesTable": {
        columns: [
            {
                "id": "0",
                "name": "Id",
                "headerName": "",
                "type": "string",
                "hidden": true
            },
            {
                "id": "1",
                "name": "shortName",
                "headerName": i18next.t("counterpartyShortName"),
                "type": "string"
            },
            {
                "id": "2",
                "name": "type",
                "headerName": i18next.t("counterpartyType"),
                "type": "string"
            },
            {
                "id": "3",
                "name": "kind",
                "headerName": i18next.t("counterpartyKind"),
                "type": "string"
            },
            {
                "id": "4",
                "name": "IPN_EDRPOUCode",
                "headerName": i18next.t("IPN_EDRPOUCode"),
                "type": "string"
            },
            {
                "id": "5",
                "name": "state",
                "headerName": i18next.t("status"),
                "type": "string"
            }
        ],
        actions: []
    },
    "tabs": [
        {
            "name": documentTabs.information,
            "label": i18next.t("generalInformation"),
            "documentTypes": []
        },
        {
            "name": documentTabs.signers,
            "label": i18next.t("signatories"),
            "tabs": [
                {
                    "name": "signers",
                    "label": i18next.t("accreditedSignatories")
                },
                {
                    "name": "externalsigners",
                    "label": i18next.t("additionalSignatories")
                }
            ],
            "documentTypes": [alfrescoTypes.counterpartyAccreditationCard]
        },
        {
            "name": documentTabs.signers,
            "label": i18next.t("signatories"),
            "documentTypes": [alfrescoTypes.forwarderContract, alfrescoTypes.incomingDocument, alfrescoTypes.outgoingDocument, alfrescoTypes.simpleCounterpartyAccreditationCard, alfrescoTypes.certificate]
        },
        {
            "name": documentTabs.connections,
            "label": i18next.t("connections"),
            "documentTypes": [alfrescoTypes.forwarderContract, alfrescoTypes.incomingDocument, alfrescoTypes.outgoingDocument, alfrescoTypes.certificate]
        },
        {
            "name": documentTabs.financialinfo,
            "label": i18next.t("financialInformation"),
            "documentTypes": [alfrescoTypes.counterpartyAccreditationCard]
        },
        {
            "name": documentTabs.contactinfo,
            "label": i18next.t("contactInformation"),
            "documentTypes": [alfrescoTypes.counterpartyAccreditationCard]
        },
        {
            "name": documentTabs.docs,
            "label": i18next.t("documents"),
            "documentTypes": [alfrescoTypes.counterpartyAccreditationCard]
        },
        {
            "name": documentTabs.comments,
            "label": i18next.t("comments"),
            "documentTypes": []
        },
        {
            "name": documentTabs.editingRights,
            "label": i18next.t("editingRights"),
            "documentTypes": [alfrescoTypes.forwarderContract, alfrescoTypes.incomingDocument, alfrescoTypes.outgoingDocument, alfrescoTypes.counterpartyAccreditationCard, alfrescoTypes.simpleCounterpartyAccreditationCard, alfrescoTypes.certificate]
        }
    ]
}